import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $createParagraphNode,
  $insertNodes,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  type LexicalCommand,
} from "lexical";
import { useEffect } from "react";

import {
  $createVideoEmbedNode,
  type VideoPlatform,
} from "../nodes/video-embed-node";

export type InsertVideoEmbedPayload = {
  videoUrl: string;
  videoId: string;
  platform: VideoPlatform;
};

export const INSERT_VIDEO_EMBED_COMMAND: LexicalCommand<InsertVideoEmbedPayload> =
  createCommand("INSERT_VIDEO_EMBED_COMMAND");

export function VideoEmbedPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_VIDEO_EMBED_COMMAND,
      (payload) => {
        const node = $createVideoEmbedNode(
          payload.videoUrl,
          payload.videoId,
          payload.platform,
        );
        const paragraph = $createParagraphNode();
        $insertNodes([node, paragraph]);
        paragraph.selectEnd();
        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
}
